/**
 * Like Object.values, but recursively flattens any child objects.
 */
const recursiveObjectValues = (obj: object) => {
  const values: Array<unknown> = [];
  const getValue = (x: unknown) => {
    if (
      x && // keeping in mind `typeof null === 'object'`
      typeof x === 'object'
    ) {
      Object.values(x).forEach(getValue);
    } else {
      values.push(x);
    }
  };
  getValue(obj);
  return values;
};

export default recursiveObjectValues;
